/**
 * Central clock. Wraps elapsed/delta time with a clamped delta (to survive tab
 * switches) and a smoothed FPS estimate used by the adaptive quality system.
 */

export class Time {
  /** Seconds since start. */
  elapsed = 0;
  /** Seconds since last frame, clamped to avoid huge jumps after a stall. */
  delta = 0;
  /** Unclamped delta, for wall-clock-sensitive logic. */
  rawDelta = 0;
  /** Monotonic frame counter. */
  frame = 0;
  /** Exponentially smoothed frames-per-second. */
  fps = 60;

  private last = 0;
  private started = false;

  /** Maximum delta in seconds; frames longer than this are treated as this long. */
  maxDelta = 1 / 15;

  tick(now: number): void {
    const t = now / 1000;
    if (!this.started) {
      this.started = true;
      this.last = t;
      return;
    }
    this.rawDelta = t - this.last;
    this.delta = Math.min(this.rawDelta, this.maxDelta);
    this.last = t;
    this.elapsed += this.delta;
    this.frame++;
    if (this.rawDelta > 0) {
      const instFps = 1 / this.rawDelta;
      this.fps += (instFps - this.fps) * 0.1;
    }
  }
}
